// extracted by mini-css-extract-plugin
export default {"stepsList":"U6xAs","stepsListItem":"_2LNAY","stepsListItemContent":"_12KV6","stepsListItemActive":"egp11","stepsListItemCompleted":"LTsDh","icon":"_2CPQY"};